// extracted by mini-css-extract-plugin
module.exports = {"datablock":"Datablock_datablock__8ZStu","content":"Datablock_content__SjpZo"};